import { normalize } from 'utils';

export const radius = {
  xs: normalize('4px'),
  sm: normalize('8px'),
  rg: normalize('12px'),
  lg: normalize('20px'),
  xl: normalize('40px'),
};

export const space = {
  xs: normalize('4px'),
  sm: normalize('8px'),
  rg: normalize('16px'),
  md: normalize('20px'),
  lg: normalize('32px'),
  xl: normalize('48px'),
  xxl: normalize('64px'),
};
